import React, { useState, useEffect, useCallback } from 'react';
import './Organizations.css';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { getOrganizations } from '../../services/Organizations';

function Organizations() {
  const navigate = useNavigate();
  const { isLoading } = useAuth();
  const [orgData, setOrganizationData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getOrganizations()
      .then((data) => {
        setOrganizationData(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Cannot get organizations', err);
        setLoading(false);
      });
  }, []);

  const handleEditClick = useCallback((orgId) => {
    navigate(`/organizations/${orgId}`);
  }, [navigate]);

  const handleCourierMonitorClick = useCallback((orgId) => {
    window.open(`/courier-monitor/${orgId}`, '_blank', 'noopener,noreferrer');
  }, []);

  if (isLoading || loading) {
    return (
      <div className="organizations-container">
        <div className="organizations-loading">
          <div className="organizations-loading-spinner"></div>
          <p>Загрузка...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="organizations-container">
      <div className="organizations-header">
        <div className="organizations-header-content">
          <h1 className="organizations-title">🏢 Организации</h1>
          <p className="organizations-subtitle">Управление филиалами и экранами</p>
        </div>
        <span className="organizations-count">{orgData.length} филиалов</span>
      </div>

      {orgData.length === 0 ? (
        <div className="organizations-empty">
          <div className="organizations-empty-icon">🏬</div>
          <h2>Нет организаций</h2>
          <p>Организации еще не добавлены</p>
        </div>
      ) : (
        <div className="organizations-grid">
          {orgData.map((org) => (
            <div key={org.id} className="organization-card">
              <div className="organization-card-icon">🏪</div>
              <div className="organization-card-content">
                <h3 className="organization-card-name">{org.name}</h3>
                <p className="organization-card-address">
                  📍 {org.restaurantAddress || 'Адрес не указан'}
                </p>
              </div>
              <div className="organization-card-actions">
                <button
                  className="organization-card-btn"
                  onClick={() => handleEditClick(org.id)}
                >
                  Редактировать
                  <span>→</span>
                </button>
                <button
                  className="organization-card-btn organization-card-btn-monitor"
                  onClick={() => handleCourierMonitorClick(org.id)}
                >
                  🛵 Монитор курьеров
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Organizations;
